/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import './index.scss'
import classnames from 'classnames'
import LazyLoad from 'react-lazyload'
import NoSSR from '@/components/rc-no-ssr'

const useIsShowSUVState = (init) => {
  const cbRef = useRef()
  const [isShowSUV, setIsShowSUV] = useState(init)

  useEffect(() => {
    cbRef.current && cbRef.current()
  }, [isShowSUV])

  return [
    isShowSUV,
    (value, cb) => {
      cbRef.current = cb
      setIsShowSUV(value)
    }
  ]
}

const ReportExterInterInspect = ({ newTestReport, defectImages, base }) => {
  const [isShowSUV, setIsShowSUV] = useIsShowSUVState(false)
  const [locaWrapperimg, setLocaWrapperimg] = useState(
    'https://img1.rrcimg.com/pc/detail-report/bottom.png'
  )

  const currRefdom = useRef()
  const detailBlemishInspect1 = useRef()
  const detailBlemishInspect2 = useRef()

  const majorObj = newTestReport
    && newTestReport.report
    && newTestReport.report['外观内饰检测']
  const majorObjTotal = newTestReport
    && newTestReport.report_count
    && newTestReport.report_count['外观内饰检测']
  const getCss = (obj, attribute) => {
    if (obj.currentStyle) {
      return obj.currentStyle[attribute]
    }

    return window.getComputedStyle(obj, null)[attribute]
  }
  useEffect(() => {
    if (base && Object.keys(base).length > 0) {
      const { carLevel, inspectVersion } = base
      // suv 车磨损图处理
      const isSUV = (inspectVersion === '6' || inspectVersion > 600)
        && ['SUV', 'MPV', '微面', '轻客'].indexOf(carLevel) > -1
      // suv 获取css
      if (isSUV) {
        setIsShowSUV(true)
        setLocaWrapperimg(
          'https://img1.rrcimg.com/pc/detail-report/bottom-suv.png'
        )
      }
    }
  }, [base])
  const handleDefectNum = defectNum => (
    <>
      <i className="iconfont icon-type-part-type-icon defectNum" />
      <span className="test-num">{defectNum}项</span>
    </>
  )
  // 插入损坏区域
  const handleDefectImg = (obj) => {
    let newArr = []
    Object.keys(obj).forEach((el) => {
      if (obj[el].status === 'normal') {
        newArr.push(null)
      } else {
        const titleArray = []
        let defectColor = ''
        let defectTxt = ''
        obj[el].items.map((it) => {
          titleArray.push(it.title)
          return null
        })
        const defectObj = {
          secha: titleArray.indexOf('色差') > -1,
          genghuan: titleArray.indexOf('更换') > -1,
          banjin: titleArray.indexOf('钣金') > -1,
          penqi: titleArray.indexOf('喷漆') > -1
        }
        if (defectObj.secha) {
          defectColor = 'yellow-img'
          defectTxt = '有色差'
        } else if (defectObj.genghuan) {
          defectColor = 'red-img'
          defectTxt = '覆盖件更换'
        } else if (defectObj.banjin) {
          defectColor = 'blue-img'
          defectTxt = '钣金修复'
        } else if (defectObj.penqi) {
          defectColor = 'gray-img'
          defectTxt = '喷漆修复'
        }
        if (defectObj.genghuan && defectObj.secha) {
          defectColor = 'red-img'
          defectTxt = '覆盖件更换'
        }
        if (defectObj.banjin && (defectObj.secha || defectObj.genghuan)) {
          defectColor = 'blue-img'
          defectTxt = '钣金修复'
        }
        if (
          defectObj.penqi
          && (defectObj.secha || defectObj.genghuan || defectObj.banjin)
        ) {
          defectColor = 'gray-img'
          defectTxt = '喷漆修复'
        }
        const temp = (
          <div
            key={el}
            className={`defect-img defect-${el} ${defectColor}`}
            ref={currRefdom}
          >
            <div className="defect-text">{`${el}:${defectTxt}`}</div>
          </div>
        )
        newArr = newArr.concat(temp)
      }
    })
    return newArr
  }
  // 插入可见伤区域外观
  const handleCategory = (defectArr) => {
    const newArr = []

    defectArr.forEach((item, index) => {
      let pointsBlock = null
      if (
        item.category
        && (item.category === '外观' || item.category === '外观瑕疵')
        && item.show === '1'
      ) {
        pointsBlock = (
          <div
            key={index}
            className="points-block detail-blemish-point"
            style={{
              position: 'absolute',
              left: `${item.pointX * 468}px`,
              top: `${item.pointY * 298}px`
            }}
          >
            <div className="twinkle-dot-block">
              <div className="solid-dot" />
              <div className="twinkle-dot" />
              {item.img_url && (
                <div className="defect-img defect-img-l hide">
                  {item.type && (
                    <p className="type-banner">
                      <span className="type-title">{item.type}</span>
                      <span className="type-desc">
                        {item.type === '裂痕' && '漆面或外覆盖件自然开裂。'}
                        {item.type === '划痕' && '伤痕较浅，未露底漆。'}
                        {item.type === '漏底伤痕' && '伤痕深度已露底漆。'}
                        {item.type === '凹陷' && '外观覆盖件有凹陷'}
                        {item.type === '破损'
                          && '外观覆盖件有外伤或自然老化破损。'}
                      </span>
                    </p>
                  )}

                  <div className="point-popup-arrow-outer" />
                  <div className="point-popup-arrow" />
                  <img
                    alt={item.category}
                    className="img-lazy"
                    src={item.img_url
                      .replace(
                        '7jpqno.com2.z0.glb.clouddn.com',
                        'img2.rrcimg.com'
                      )
                      .replace('rrcdn.qiniudn.com', 'img2.rrcimg.com')
                      .replace('static.renrenche.com', 'img2.rrcimg.com')
                      .replace('http://', '//')}
                  />
                </div>
              )}
            </div>
          </div>
        )
        newArr.push(pointsBlock)
      }
    })
    return newArr
  }
  // 插入可见伤区域内饰
  const handleCategoryInsert = (defectArr) => {
    const newArr = []
    defectArr.forEach((item, index) => {
      let pointsBlock = null
      if (item.category && item.category === '内饰' && item.show === '1') {
        pointsBlock = (
          <div
            key={index}
            className="points-block detail-blemish-point"
            style={{
              position: 'absolute',
              left: `${item.pointX * 344}px`,
              top: `${item.pointY * 268}px`
            }}
          >
            <div
              className="twinkle-dot-block"
              data-hover="pc-car-detail-appearance-flaw"
            >
              <div className="solid-dot" />
              <div className="twinkle-dot" />
              {item.img_url && (
                <div className="defect-img defect-img-r">
                  <div className="point-popup-arrow-right-outer" />
                  <div className="point-popup-arrow-right" />
                  <img
                    alt={item.category}
                    className="img-lazy"
                    src={item.img_url
                      .replace(
                        '7jpqno.com2.z0.glb.clouddn.com',
                        'img2.rrcimg.com'
                      )
                      .replace('rrcdn.qiniudn.com', 'img2.rrcimg.com')
                      .replace('static.renrenche.com', 'img2.rrcimg.com')
                      .replace('http://', '//')}
                  />
                </div>
              )}
            </div>
          </div>
        )
        newArr.push(pointsBlock)
      }
    })
    return newArr
  }
  const insterPopover = (arr) => {
    const newArr = []
    arr.forEach((item, index) => {
      newArr.push(
        <div key={index} className="report-case-des-content">
          <p className="report-case-des-title">{item.title}</p>
          <p className="report-case-des-word">{item.description}</p>
        </div>
      )
    })
    return newArr
  }
  const slightInvesItem = (key, arr) => {
    const newArr = []
    arr.forEach((item, index) => {
      if (majorObj[key] && majorObj[key][item].status === 'normal') {
        newArr.push(
          <div key={index} className="content-item ellips clearfixnew">
            <i className="iconfont icon-test_smicon" />
            <span className="pass_item_name">{item}</span>
          </div>
        )
      } else {
        newArr.push(
          <div key={index} className="content-item ellips anomaly clearfixnew">
            <i className="iconfont icon-tip-icon2-07d8d303" />
            <span className="pass_item_name test-item-name">{item}</span>
            <div className="report-case-des-box">
              <div className="report-case-des-wraper">
                <span className="report-case-des-arrow">
                  <span className="report-case-arrow-inside" />
                </span>
                {insterPopover(majorObj[key][item]?.items)}
              </div>
            </div>
          </div>
        )
      }
    })
    return newArr
  }

  return (
    <>
      <NoSSR>
        <div
          className="major_acc_inves"
          id="part-report-detail-外观内饰检测"
          data-exposure={JSON.stringify({
            event: 'ReportDetailPage_ReportsDetail_display',
            content: { expand: { value: '外观内饰检测' } }
          })}
        >
          <LazyLoad offset={100} height={1304}>
            <div className="title">
              <span className="acc_name">外观内饰检测 </span>
              <span className="hg_sign">合格</span>
              <span className="title_des ellips">
                {majorObjTotal?.text_report}
              </span>
            </div>
            <div className="appence-item">
              <i className="iconfont icon-waiguan" />
              <div className="case_head">
                <p className="case_title">外观</p>
                <div className="case_num">
                  <i className="iconfont icon-test_icon" />
                  <span className="test-num">
                    {majorObjTotal && majorObjTotal['外观检测'].total_pass_num}
                    项
                  </span>
                  {majorObjTotal
                    && majorObjTotal['外观检测'].defect_num !== 0
                    && handleDefectNum(majorObjTotal['外观检测'].defect_num)}
                </div>
              </div>

              <div className={classnames('detail_wrapper', { suv: isShowSUV })}>
                <div className="img-position appearance-outside-img appearance-suv">
                  <img
                    src={locaWrapperimg}
                    alt="轿车-bottom"
                    className="car-bottom"
                    ref={detailBlemishInspect1}
                  />
                  {majorObj && handleDefectImg(majorObj['外观检测'])}
                  {/* 可见伤 */}
                  {defectImages
                    && defectImages.length > 0
                    && handleCategory(defectImages)}
                </div>
                {/* 事例 */}
                <div className="detail-blemish-inspect">
                  <li>
                    <i className="penqi" />
                    <span>喷漆修复</span>
                  </li>
                  <li>
                    <i className="banjin" />
                    <span>钣金修复</span>
                  </li>
                  <li>
                    <i className="genghuan" />
                    <span>覆盖件更换</span>
                  </li>
                  <li>
                    <i className="secha" />
                    <span>有色差</span>
                  </li>
                  <li>
                    <i className="circle" />
                    <span>可见伤</span>
                  </li>
                </div>
              </div>
              {/* 检测项 */}
              <div className="appearance-item-content clearfixnew">
                {majorObj
                  && slightInvesItem(
                    '外观检测',
                    Object.keys(majorObj['外观检测'])
                  )}
              </div>
            </div>
            <div className="appence-item">
              <i className="iconfont icon-neishi" />
              <div className="case_head">
                <p className="case_title">内饰</p>
                <div className="case_num">
                  <i className="iconfont icon-test_icon" />
                  <span className="test-num">
                    {majorObjTotal && majorObjTotal['内饰检测'].total_pass_num}
                    项
                  </span>
                  {majorObjTotal
                    && majorObjTotal['内饰检测'].defect_num !== 0
                    && handleDefectNum(majorObjTotal['内饰检测'].defect_num)}
                </div>
              </div>
              <div
                className={classnames('detail_wrapper_inside', {
                  suv: isShowSUV
                })}
              >
                <div className="img-position appearance-outside-img">
                  <img
                    src="https://img1.rrcimg.com/pc/detail-report/inside.png"
                    alt="内饰"
                    className="inside-car-img"
                    ref={detailBlemishInspect2}
                  />
                  {majorObj && handleDefectImg(majorObj['内饰检测'])}
                  {defectImages
                    && defectImages.length > 0
                    && handleCategoryInsert(defectImages)}
                </div>
              </div>
              <div className="detail-blemish-inspect">
                <li>
                  <i className="penqi" />
                  <span>喷漆修复</span>
                </li>
                <li>
                  <i className="banjin" />
                  <span>钣金修复</span>
                </li>
                <li>
                  <i className="genghuan" />
                  <span>覆盖件更换</span>
                </li>
                <li>
                  <i className="secha" />
                  <span>有色差</span>
                </li>
                <li>
                  <i className="circle" />
                  <span>可见伤</span>
                </li>
              </div>
              <div className="appearance-item-content clearfixnew">
                {majorObj
                  && slightInvesItem(
                    '内饰检测',
                    Object.keys(majorObj['内饰检测'])
                  )}
              </div>
            </div>
          </LazyLoad>
        </div>
      </NoSSR>
    </>
  )
}

export default ReportExterInterInspect

ReportExterInterInspect.propTypes = {
  newTestReport: PropTypes.object,
  defectImages: PropTypes.array,
  base: PropTypes.object
}

ReportExterInterInspect.defaultProps = {
  newTestReport: {},
  defectImages: [],
  base: {}
}
